import fetch from 'isomorphic-fetch'

const API_URL = process.env.REACT_APP_AVT_API_URL

export type HttpRequest = {
  method: string
  endpoint: string
  body?: unknown
  queryParams?: unknown
}

export class AvtGateway {
  static async executeGetRequest<T>(request: HttpRequest): Promise<T> {
    const requestUrl = `${API_URL}${request.endpoint}${generateQueryParams(request.queryParams)}`
    const fetchRequestObject = createFetchRequest(
      {
        method: 'GET'
      },
      null
    )
    return fetch(requestUrl, fetchRequestObject)
  }
  static async executePostRequest<T>(request: HttpRequest): Promise<T> {
    const requestUrl = `${API_URL}${request.endpoint}${generateQueryParams(request.queryParams)}`
    const fetchRequestObject = createFetchRequest(
      {
        method: 'POST',
        body: request.body
      },
      null
    )
    return fetch(requestUrl, fetchRequestObject)
  }
  static async executePutRequest<T>(request: HttpRequest): Promise<T> {
    const requestUrl = `${API_URL}${request.endpoint}${generateQueryParams(request.queryParams)}`
    const fetchRequestObject = createFetchRequest(
      {
        method: 'PUT',
        body: request.body
      },
      null
    )
    return fetch(requestUrl, fetchRequestObject)
  }
  static async executePatchRequest<T>(request: HttpRequest): Promise<T> {
    const requestUrl = `${API_URL}${request.endpoint}${generateQueryParams(request.queryParams)}`
    const fetchRequestObject = createFetchRequest(
      {
        method: 'PATCH',
        body: request.body
      },
      null
    )
    return fetch(requestUrl, fetchRequestObject)
  }
  static async executeDeleteRequest<T>(request: HttpRequest): Promise<T> {
    const requestUrl = `${API_URL}${request.endpoint}${generateQueryParams(request.queryParams)}`
    const fetchRequestObject = createFetchRequest(
      {
        method: 'DELETE',
        body: request.body
      },
      null
    )
    return fetch(requestUrl, fetchRequestObject)
  }
}

const createFetchRequest = (requestObj, fromData) => {
  return {
    method: requestObj.method,
    headers: requestObj.headers || {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: fromData ? requestObj.body : JSON.stringify(requestObj.body)
  }
}

const generateQueryParams = (params): string => {
  if (typeof params === 'object') {
    return `?${Object.keys(params)
      .map((key) => {
        if (Array.isArray(params[key])) {
          return params[key]
            .map((param) => {
              return `${encodeURIComponent(key)}[]=${encodeURIComponent(param)}`
            })
            .join('&')
        }

        return `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`
      })
      .join('&')}`
  }

  return ''
}
